export const ACCOUNT_ADMIN_URL: string = 'account/{accountId}/settings';
